import {useEffect, useState} from "react";
import { apiRequest } from "../../network/apiClient";
import {API_ENDPOINTS} from "../../api/apiEndpoints";

export const useAccDetDetails = ({leadID}) =>{
    const [leadJourney, setLeadJourney] = useState([]);
    const [accDets, setAccDets] = useState([]);
    const [associatedProd, setAssociatedProd] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchData = async () =>{
        if (!leadID) return;
        
        setLoading(true);
        try{

            // Get Details using Lead Journey Table API
            const resultDetails = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_LEADS.JOURNEY}?lead_id=${leadID}`, 'GET');
            if (resultDetails) {
                // console.table("Details Data:", resultDetails);
                setLeadJourney(resultDetails);
                setAssociatedProd(resultDetails.associated_products);
            } else {
                console.error("Failed to fetch lead journey:", resultDetails.error);
            }

            // Get Extra details using Account Details Table API
            const resultAccTable = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_ACCOUNTS.DETAILS}?lead_id=${leadID}`, 'GET');
            if (resultAccTable) {
                setAccDets(resultAccTable);
            } else {
                console.error("Failed to fetch account details:", resultAccTable.error);
            }
        }catch (error){
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() =>{
        if (!leadID) return;
        if (leadID) {
            fetchData();
        }
    }, [leadID]);
    
    return {leadJourneyAPI: leadJourney, accDetsAPI: accDets, associatedProdAPI: associatedProd, loading, refetch: fetchData};
}
